<template>
	<div>
		<modalconfirm ref="modalSave" @action="saveSetting"/>
		<div class="text-h5">Setting Minimum BV Belanja Stockist</div>
		<v-col cols="6">
            <v-card class="mt-3" outlined>
				<v-card-text class="pt-2 pb-0">
                    <v-row>
                        <v-col cols="12" style="color: red;">
							* Harap hanya melakukan perubahan pada pukul 03:30 - 05:30 WIB
						</v-col>
					</v-row>
				</v-card-text>
                <v-card-text class="pt-2">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="bv" outlined dense label="Minimum BV"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" :disabled="bv == ''" depressed class="text-capitalize" @click="sync">Simpan</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
	</div>
</template>

<script>

import {mapActions, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			bv: 0,
		}
	},
	props: {
	},
	computed: {
	},
	methods: {
		...mapActions('purchaseOrderStockist', ['getMinimumBV', 'saveMinimumBV']),
		...mapMutations(['setOverlay']),

		sync() {
			let msg = `Yakin ingin menyimpan data?`
			this.$refs.modalSave.showConfirm()
			this.$refs.modalSave.setMessage(msg)
		},
		async saveSetting() {
			await this.setOverlay(true)
			await this.$refs.modalSave.hideConfirm()
			let params = await {
				bv: this.bv
			}

			await this.saveMinimumBV(params).then(() => {
				this.resetForm()
			})
			await this.setOverlay(false)
		},
		resetForm() {
			this.getBV()
		},
		async getBV() {
			await this.getMinimumBV().then((response) => {
				//console.log(response)
                this.bv = response.options_value
			}).catch(() => {
				//console.log(response)
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Setting Minimum BV Belanja Stockist`)
		this.getBV()
	},
	beforeDestroy() {
	},
	watch: {
		
	}
}
</script>